export default __webpack_public_path__ + "static/media/mobilepayout.ca095d16.png";